import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation, faWifi, faUser } from "@fortawesome/free-solid-svg-icons";
import { WifiSlashIcon } from "../icons/wifi-slash";
import { Badge } from "react-bootstrap";
import { useState } from "preact/hooks";
import IsicomConsole from "../isicom-console";
import Dropdown from "react-bootstrap/Dropdown";
import agentStates from "../../lib/isicom/agentStates";

export default function IsicomStatus(props) {
    const [showConsole, setShowConsole] = useState(false);

    function getIsiComBadgeColor() {
        switch (props.isicom?.agentStatus?.code) {
            case "unavailable":
            case "busy":
                return "danger";
            case "available":
                return "success";
            case "in_call":
                return "warning";
            default:
                return "info";
        }
    }

    function toggleConsole() {
        setShowConsole(!showConsole);
    }

    function getAvAgentStates() {
        return Object.values(agentStates).filter((state) => {
            if (!state.display) {
                return false;
            }

            return state.code !== props.isicom.agentStatus.code
        });
    }

    function changeState(state) {
        props.isicom.changeAgentState(state);
    }

    return (
        <>
            {showConsole ? <IsicomConsole show={showConsole} onHide={toggleConsole} /> : null}
            <div className={`d-flex align-items-center justify-content-center gap-4`}>
                {props.isicom ? (
                    <>
                        <Badge bg="light text-dark">
                            {props.isicom.isConnected() ? (
                                <>
                                    <FontAwesomeIcon onClick={toggleConsole} className={"blinking"} icon={faWifi} />
                                </>
                            ) : (
                                <>
                                    {/* TB: J'utilise ici un icon custom, car l'icon wifi slash n'est pas dispo sur fontawesome free */}
                                    <WifiSlashIcon width={12} height={12} />
                                </>
                            )}
                        </Badge>
                        {props.isicom.isConnected() && props.isicom.agentStatus ? (
                            <>
                                <Dropdown>
                                    <Dropdown.Toggle variant={getIsiComBadgeColor()} id="dropdown-basic">
                                        <FontAwesomeIcon icon={faUser} /> {props.isicom.agentStatus.label}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        {getAvAgentStates().map((state) => {
                                            return <Dropdown.Item onClick={() => changeState(state)}>{state.label}</Dropdown.Item>;
                                        })}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </>
                        ) : null}
                    </>
                ) : null}
            </div>
        </>
    );
}
